import { freeze } from 'icepick';
import type { ErrorInfo } from 'react';
import { SET } from './actions';
import { type ExternalState } from './types';
import type { AnalyticsMeta } from '../../view/types';
import { type AnyAction } from 'redux';
import { Reasons } from '@atlassiansox/cross-flow-component-support';

export const initialExternalState: ExternalState = freeze({
	onGetFeatureFlagValue: () => ({
		// example FF
		// isGrapeOn: (defaultValue) => defaultValue,
	}),
	onFireExposureEvent: (flagKey: string) => ({
		// example FF
		// Call to fire feature exposed
	}),
	onFireErrorEvent: (error: Error, info: ErrorInfo, meta?: AnalyticsMeta) => ({
		// Do something with the error, e.g. log to Sentry
	}),
	crossFlow: {
		isEnabled: false,
		reason: Reasons.NO_PROVIDER,
	},
});

export default (state: ExternalState = initialExternalState, action: AnyAction): ExternalState => {
	switch (action.type) {
		case SET: {
			return freeze(action.payload);
		}
		default:
			return state;
	}
};
